export default "__VITE_ASSET__c4fa2888__"